declare global {
 interface Window {BBI18n?:{t(source:string,params?:Record<string,string|number>,locale?:string):string;apply(root?:Node):void;markup(html:string):string;ready:Promise<boolean>;setLocale(code:string):void;locale:string;locales:string[];};}
}
export const translate=(source:string,params?:Record<string,string|number>,locale?:string):string=>{
 const service=typeof window==='undefined'?undefined:window.BBI18n;
 if(service)return service.t(source,params,locale?.split('-')[0]);
 let text=source;for(const[key,value]of Object.entries(params??{}))text=text.replaceAll(`{${key}}`,String(value));return text;
};
export const localize=(root:Node):void=>{root.ownerDocument?.defaultView?.BBI18n?.apply(root);};
export const localizeMarkup=(html:string):string=>typeof window==='undefined'?html:window.BBI18n?.markup(html)??html;
